module.exports = __webpack_public_path__ + "img/data-not-found.9650d0db.svg";